import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-yellow-500/20 backdrop-blur-sm border border-yellow-500/30 rounded-full mb-8">
            <i className="ri-time-line text-yellow-400 mr-2"></i>
            <span className="text-yellow-300 font-semibold text-sm">Get Pre-Qualified in Minutes</span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Ready to Finance Your
            <span className="block mt-2 bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
              Next Investment Property?
            </span>
          </h2>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-blue-200 max-w-3xl mx-auto mb-12 leading-relaxed">
            Join 10,000+ investors who chose DSCR loans for fast, flexible financing. 
            No income verification. No hassle. Just results.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link
              to="/apply"
              className="group px-8 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-slate-900 rounded-lg font-bold text-lg hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-2xl hover:shadow-yellow-500/50 hover:scale-105 whitespace-nowrap w-full sm:w-auto"
            >
              <span className="flex items-center justify-center">
                Apply Now - It's Free
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
            <a
              href="tel:3475860671"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-bold text-lg hover:bg-white/20 hover:border-white/50 transition-all whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-phone-line mr-2"></i>
              Call 347-586-0671
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center items-center gap-8 text-blue-200">
            <div className="flex items-center">
              <i className="ri-checkbox-circle-fill text-yellow-400 text-2xl mr-2"></i>
              <span className="font-semibold">No Credit Check</span>
            </div>
            <div className="flex items-center">
              <i className="ri-checkbox-circle-fill text-yellow-400 text-2xl mr-2"></i>
              <span className="font-semibold">3-Minute Application</span>
            </div>
            <div className="flex items-center">
              <i className="ri-checkbox-circle-fill text-yellow-400 text-2xl mr-2"></i>
              <span className="font-semibold">Close in 21 Days</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
